import * as React from "react";
import { Button, Divider, Container } from "semantic-ui-react";

import { CreateMHPTreatmentCaseModal } from "../../mentalHealthPractitionerTreatment/components/CreateMHPTreatmentCaseModal";

interface Props {
    linkedOhCaseId: string;
}

export const CreateLinkedMHPCaseButton: React.FunctionComponent<Props> = (props: Props) => {

    const [open, setOpen] = React.useState<boolean>(false);

    const openModal = () => setOpen(true);

    return (
        <>
            <Divider />
            <Container textAlign="right">
                <Button onClick={openModal} content="Open MHP Treatment Case"></Button>
            </Container>
            <CreateMHPTreatmentCaseModal linkedOhCaseId={props.linkedOhCaseId} open={open} onClose={() => setOpen(false)} />
        </>
    );
};
